import React, { useEffect, useState } from "react";
import StatusBadge from "./StatusBadge";
import SearchOffersReq from "../../../../Requests/Offer/SearchOffersReq";
import OfferApi from "../../../../API/OfferApi";
import convertUTCToCST from "../../../../Services/DateFormatter";
function ReportDetails({
  offersCount,
  salesRepId,
  startDate,
  endDate,
  opendOffers,
  acceptedOffers,
}) {
  const [offers, setOffers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 8;
  const totalOffers = offersCount || 0;
  // const openedCount = offers.filter((offer) => offer.opened).length;
  // const acceptedCount = offers.filter((offer) => offer.accepted).length;

  const getFormattedDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = dateStr;
    return convertUTCToCST(date)
  };

  const totalPages = Math.ceil(offersCount / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const getOffersDetails = async () => {
    try {
      const req = new SearchOffersReq();
      req.salesRepId = salesRepId;
      req.startDate = startDate;
      req.endDate = endDate;
      req.pagingParams.pageNumber = currentPage;
      req.pagingParams.pageSize = itemsPerPage;

      const res = await OfferApi.SearchOffers(req);
      if (res?.status?.success) {
        setOffers(res.data.list || []);
      }
    } catch (err) {
      console.error("Error fetching offers report data:", err);
    }
  };

  useEffect(() => {
    getOffersDetails();
  }, [currentPage]);
  return (
    <tr className="bg-gray-50">
      <td colSpan="5" className="px-4 py-4 border-b border-t border-gray-200">
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm">
          {/* Stats Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100">
              <p className="text-sm text-amber-700 font-medium mb-1">
                Open Rate
              </p>
              <p className="text-2xl font-bold text-amber-800">
                {totalOffers > 0
                  ? Math.round((opendOffers / totalOffers) * 100)
                  : 0}
                %
              </p>
              <p className="text-xs text-amber-600 mt-1">
                {opendOffers} of {totalOffers} offers
              </p>
            </div>
            <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100">
              <p className="text-sm text-emerald-700 font-medium mb-1">
                Acceptance Rate
              </p>
              <p className="text-2xl font-bold text-emerald-800">
                {totalOffers > 0
                  ? Math.round((acceptedOffers / totalOffers) * 100)
                  : 0}
                %
              </p>
              <p className="text-xs text-emerald-600 mt-1">
                {acceptedOffers} of {totalOffers} offers
              </p>
            </div>
          </div>

          {/* Offers Table */}
          <h4 className="font-medium text-gray-700 mb-3">Individual Offers</h4>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ID
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Opened
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Accepted
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {console.log("currentOffers", offers)}
                {offers.map((offer) => (
                  <tr
                    key={offer.id}
                    className="hover:bg-gray-50 border-t border-gray-100"
                  >
                    <td className="px-3 py-2 font-medium">{offer.id}</td>
                    <td className="px-3 py-2">
                      <StatusBadge status={offer.opened} type="opened" />
                    </td>
                    <td className="px-3 py-2">
                      <StatusBadge status={offer.accepted} type="accepted" />
                    </td>
                    <td className="px-3 py-2 text-sm text-gray-500">
                      {getFormattedDate(offer.timeStamp)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalOffers && (
            <div className="mt-4 flex items-center justify-center gap-2 flex-wrap text-sm">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
              >
                &lt; Previous
              </button>

              {/* Always show first page */}
              <button
                onClick={() => setCurrentPage(1)}
                className={`px-3 py-1 border rounded ${
                  currentPage === 1
                    ? "bg-black text-white"
                    : "hover:bg-gray-100"
                }`}
              >
                1
              </button>

              {/* Dots after 1 if currentPage > 3 */}
              {currentPage > 3 && <span className="px-2">...</span>}

              {/* Pages around current */}
              {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                .filter(
                  (page) =>
                    page > 1 &&
                    page < totalPages &&
                    page >= currentPage - 1 &&
                    page <= currentPage + 1
                )
                .map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-3 py-1 border rounded ${
                      currentPage === page
                        ? "bg-black text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {page}
                  </button>
                ))}

              {/* Dots before last page */}
              {currentPage < totalPages - 2 && (
                <span className="px-2">...</span>
              )}

              {/* Last Page */}
              {totalPages > 1 && (
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className={`px-3 py-1 border rounded ${
                    currentPage === totalPages
                      ? "bg-black text-white"
                      : "hover:bg-gray-100"
                  }`}
                >
                  {totalPages}
                </button>
              )}

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
              >
                Next &gt;
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}

export default ReportDetails;
